import { Subscription } from 'rxjs';
import { Component, OnInit, TemplateRef, Input, Output, EventEmitter, OnDestroy, Pipe, PipeTransform, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/pages/common/api.service';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { ConfirmEmaiModalComponent } from 'src/app/authentication/confirm-email-modal/confirm-email-modal.component';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
  providers: [GlobalConstants]
})
export class AuthenticationComponent implements OnInit, OnDestroy {

  @ViewChild('visaIFrame') visaIFrame: any;

  private subject: Subject<string> = new Subject();
  @Input() showAuthentication: boolean = false;
  @Output() reloadHeader = new EventEmitter();
  IDLE_TIMEOUT = 900;
  _idleSecondsTimer = null;
  _idleSecondsCounter = 0;
  showLoggedOut: boolean = false;
  stepToShow: string;
  
  modalRef: BsModalRef;
  allCountries: any = [];
  selectedCountry: any;

  showStepZero: boolean = false;
  notApplicableCard = false;

  ifExistingUser: boolean = true;
  showIfNotAuthenticated: boolean = false;
  invalidUser: boolean = false;
  userSearching: boolean = false;
  errorRequestingOtp: boolean = false;
  invalidOtp: boolean = false;
  validOtp: boolean = false;
  invalidCard: boolean = false;
  userId: any;
  urlcode: any;
  uid: any;
  apiclient: any;
  otpInp: any;
  authenticated_user: boolean = false;
  mobileInputBtnActive: any = false;
  emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  createWithUserForm: any = this.fb.group({
    mobile: ['', [Validators.required]],
    email: ['', [Validators.email, Validators.pattern(this.emailPattern)]]
  });
  userCardJson: any;
  userCardsText: string;
  get f() { return this.createWithUserForm.controls; }
  mobNum: any;
  validateUserOtpForm: any = this.fb.group({
    userId: [''],
    otp: [''],
  });
  addCardForm: any = this.fb.group({
    binFirst4: [''],
    binLast4: [''],
    binLast1: ['']
  });
  thebin = '';
  isload1: boolean = false;
  isload2: boolean = false;
  loginProgress: boolean = false;
  timer: any = 'initial';
  viewTimer: any = 0;
  timerToShow: any;
  userStatus: any = "login";
  userCards: any = [];
  binError: boolean = false;
  binInvalid: boolean = false;
  cardVerified: boolean = false;
  submittedForm1: boolean;
  errorRequestingOtpMsg: string;
  searchLoader: boolean = false;
  otpVerifying: boolean = false;
  showNoCards: boolean = false;
  showNoCardsMessage: any = "";
  fetchingCard: boolean = false;
  cardNum: any;
  featuredCountryCodes = ['IND', 'SGP', 'ARE', 'AUS', 'USA', 'GBR', 'CAN', 'SAU', 'KWT', 'QAT', 'BHR', 'OMN', 'HKG', 'NZL', 'BGD'];
  popularCountries = [];
  otherCountries = [];
  countrySearchTerm = '';
  public iFrameData: {
    expires_at: string
    txn_id: string
    url: string
  };
  currentStep = 0;
  isMobile = false;
  userEnteredDetails = {
    num : '',
    code: '',
    alreadyChecked : false
  }

  userEmail: any;
  iFrameLoaded: boolean

  private subscriptions: Subscription[] = []
  clearAll(){
    this.currentStep = 0;
    this.cardNum = null;
    this.fetchingCard = false;
    this.showNoCards = false;
    this.otpVerifying = false;
    this.searchLoader = false;
    this.submittedForm1 = false;
    this.binError = false;
    this.isload1 = false;
    this.isload2 = false;

    this.cardVerified = false;
    this.binInvalid = false;
    this.ifExistingUser = true;
    this.showNoCardsMessage = '';
    this.errorRequestingOtpMsg = '';
    this.createWithUserForm.patchValue({ mobile: '' });
    this.createWithUserForm.patchValue({ email: '' });
    this.mobNum = undefined;
    this.otpInp = undefined;
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _apiService: ApiService,
    public GlobalConstants: GlobalConstants,
    private fb: UntypedFormBuilder,
    private _auth: AuthenticationService,
    private _modalService: BsModalService,
    private toastr: ToastrService,
    private dataTransferService: DataTransferService,
    @Inject(LOCALE_ID) public locale: string,
  ) {
    //function to accept visa token from iframe
    (<any>window).validateToken= this.validateToken.bind(this);
    if (localStorage.getItem("currentUser")) {
      this.authenticated_user = true;
    }
    else {
      this.authenticated_user = false;
      let isInfoPage = false;
      if(this.router.url.includes('info')) isInfoPage = true;
      if (this.GlobalConstants.data.personalized_config.force_auth  && (!sessionStorage.getItem('cancelabled_auth') && !isInfoPage) || this.showAuthentication) {
        if (!this.GlobalConstants.data.personalized_config.token_auth && !this.GlobalConstants.data.bin_login) {
          this.showIfNotAuthenticated = true;
          // this._auth.currentUserValue.subscribe((response) => {
          //   if (response && response.id) {
          //     this.showIfNotAuthenticated = false;
          //     if (this.cardVerified == false) {
          //       this.getUserCard();
          //     }
          //   } else {
          //     this.getAllCountries();
          //     this.showIfNotAuthenticated = true;
          //   }
          // },
          //   err => {
          //     this.getAllCountries();
          //     this.showIfNotAuthenticated = true
          //   });
        }
      }
    }

    this._auth.errorEvent.subscribe((res) => {
      if (res) {
        this.restartLogin();
        this._auth.updateCurrentUser(null);
      }
    })
    this._auth.reloadInit.subscribe((res) => {
      if (res) {
        this.reloadInit();
      }
    })
    this._auth.showVerifyEmailEvent.subscribe((res) => {
      if (res) {
        this.showEmailConfirm()
      }
    })
  }

  ngOnInit() {
    this.currentStep = 0;
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    this.stepToShow = this.GlobalConstants.data.login_steps[0];
    this.route.fragment.subscribe((fragment: string) => {
      if (fragment == 'login' && !localStorage.getItem("currentUser")) {
        this.showIfNotAuthenticated = true;
      }
    })
    if (localStorage.getItem('iFrameData') && this.route.snapshot.queryParams.isVCESRedirect) {
      this.iFrameData = JSON.parse(localStorage.getItem('iFrameData'));
      const urlTree = this.router.createUrlTree([], {
        queryParams: {isVCESRedirect: null},
        queryParamsHandling: 'merge',
        preserveFragment: true,
      })
      this.router.navigateByUrl(urlTree)
      this.validateToken();
    } else {
      this.getIFrameToken();
    }
    let card_verified = localStorage.getItem('card_verified');
    if (card_verified == "false") {
      this._auth.logout();
      this.cardVerified = false;
    }
    else {
      this.cardVerified = true;
    }

    if (localStorage.getItem("currentUser")) {
      let emailVerified = JSON.parse(localStorage.getItem("ev"));
      if(!emailVerified){
        this.getUserDetails()
      }
    }

    // this.subject.pipe(
    //   debounceTime(500)
    // ).subscribe(inp => {
    //   this.userSearch();
    // });
    // this.createWithUserForm.get('mobile').valueChanges.pipe(debounceTime(300)).subscribe( value => {if(value) this.userSearch()});
  }
  debouncedUserSearch(inp: any) {
    this.subject.next(inp);
  }
  reloadInit() {
    this.ngOnInit();
    this.reloadHeader.emit();
  }
  removeLetter(str) {
    this.createWithUserForm.controls['mobile'].setValue(str.replace(/\D/g, ""));
    if (this.createWithUserForm.value.mobile.length > (this.selectedCountry.min_mobile_digit - 1) && this.createWithUserForm.value.mobile.length < (this.selectedCountry.max_mobile_digit + 1)) {
      this.mobileInputBtnActive = true;
    }
    else{
      this.mobileInputBtnActive = false;
    }
  }


  userSearch() {

    this.isload1 = false;
    this.errorRequestingOtpMsg = "";
    this.userId = "";
    this.ifExistingUser = true;
    if (this.createWithUserForm.value.mobile?.length > (this.selectedCountry.min_mobile_digit - 1) && this.createWithUserForm.value.mobile?.length < (this.selectedCountry.max_mobile_digit + 1)) {
        if(this.GlobalConstants.client === 'smeoffers') {
          if (
            this.userEnteredDetails.alreadyChecked && 
            this.userEnteredDetails.num === this.createWithUserForm.value.mobile && 
            this.userEnteredDetails.code == this.selectedCountry.calling_codes[0]
            ) {
            this.createUser();
          } else {
            this.searchLoader = true;
            this.userSearching = true;
            this.mobileInputBtnActive = false;
            this._auth.validateExistingUser(this.createWithUserForm.value.mobile, this.selectedCountry.calling_codes[0]).subscribe((response) => {
              this.mobileInputBtnActive = true;
              this.userSearching = false;
              this.searchLoader = false;
              
              if (response?.id) {
                this.ifExistingUser = true;
                this.userId = response.id;
                this.getUserCard()
                var current_user = {
                  id: response.id,
                  // token: response.token
                }
                localStorage.setItem('currentUser', JSON.stringify(current_user));
                if (this.locale === 'ja' || this.selectedCountry?.iso2_code === 'JP') {
                  localStorage.setItem('isJaToken', 'true');
                }
                this._auth.updateCurrentUser(current_user)
              } else {
                // show email 
                  this.userSearching = false;
                  this.searchLoader = false;
                  this.ifExistingUser = false;
                  this.userId = "";
                  // if(this.userEnteredDetails.alreadyChecked) {
                    this.createUser()
                  // }
              }
              this.userEnteredDetails = {
                num: this.createWithUserForm.value.mobile,
                alreadyChecked: true,
                code: this.selectedCountry.calling_codes[0]
              }
            }, (error) => {
              this.errorRequestingOtpMsg = $localize`Request limit exceeded. Please try after 30 mins.`
              this.mobileInputBtnActive = true;
              this.userSearching = false;
              this.searchLoader = false;
            })
          }

        } else {
          this._auth.validateExistingUser(this.createWithUserForm.value.mobile, this.selectedCountry.calling_codes[0]).subscribe((response) => {
            this.mobileInputBtnActive = true;
            this.userSearching = false;
            this.searchLoader = false;
            if (response && response.mobile == this.createWithUserForm.value.mobile) {
              this.ifExistingUser = true;
              this.userId = response.id;

              if (this.GlobalConstants.data.login_theme == 2) {
                this.cardVerified = true;
                localStorage.setItem('card_verified', "true");
              }
            } else {
                this.userSearching = false;
                this.searchLoader = false;
                this.ifExistingUser = false;
                this.userId = "";
            }
          })
        }
    }
    else {
      this.mobileInputBtnActive = false;
    }
  }

  closeAuthentication() {
    this.clearAuthStorage();
    this.dataTransferService.nextBannerInterval(5000)
    this.showIfNotAuthenticated = false;
    this.iFrameData = null;
    localStorage.removeItem('iFrameData');
    if(this.GlobalConstants.client == 'smeoffers')
    sessionStorage.setItem("cancelabled_auth", JSON.stringify(true));
  }
  clearAuthStorage(){
    localStorage.removeItem('currentUser');
    localStorage.removeItem('card_verified');
    localStorage.removeItem('cardSelected');
    localStorage.removeItem('uC');
    localStorage.removeItem('uCs');
    localStorage.removeItem('redirectData');
    localStorage.removeItem('headerLogin');
  }
  showMergedOtp: boolean = false;
  authenticateUser(event: any, goTonextStep = true) {
    this.isload1 = true;
    this.errorRequestingOtpMsg = "";
    this.submittedForm1 = true;
    // event.preventDefault();
    if (this.userSearching) {
      this.isload1 = false;
      return false;
    }
    if (this.ifExistingUser && this.userId != "" && this.userId != undefined) {
      this.userStatus ="login";
      this.requestPoshvineOtp(goTonextStep);
    }
    else if (this.createWithUserForm.valid || this.GlobalConstants.client === 'mastercard') {
      this.createUser();
    } else {
      this.isload1 = false;
      return false;
    }
  }

  requestPoshvineOtp(goTonextStep = true) {
    this._auth.requestUserOtp(this.createWithUserForm.value.mobile, this.userId).subscribe((response) => {
      if (response) {
        this.submittedForm1 = false;
        this.countDown(180, () => {
          this.timer = 'complete';
        });
        setTimeout(() => {
          this.showStepZero = false;
          this.isload1 = false;
          if(goTonextStep){
            this.currentStep = this.currentStep + 1;
            this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
          }
        }, 1000);
        setTimeout(() => {    //<<<---    using ()=> syntax
          document.getElementById("otp-field")?.focus();
        }, 1800);
      } else {
        this.isload1 = false;
        this.isload2 = false;
        this.errorRequestingOtpMsg = $localize`OTP Request limit exceeded. Please try after 30 mins.`;
        this.errorRequestingOtp = true;
        this.submittedForm1 = false;
      }
    }, error => {
      this.isload1 = false;
      this.isload2 = false;
      this.submittedForm1 = false;
      if(error.status == 422){
        this.errorRequestingOtpMsg = $localize`OTP Request limit exceeded. Please try after 30 mins.`;
        this.errorRequestingOtp = true;
      }
      else{
        this.toastr.error($localize`Something went wrong. Please try again!`);
      }
    })
  }

  createUser() {
    this.submittedForm1 = true;
    if(this.createWithUserForm.valid) {
      this._auth.createUser(this.createWithUserForm.value.mobile, this.createWithUserForm.value.email, this.selectedCountry.calling_codes[0]).subscribe((response) => {
  
        if (response && response.id) {
          this.showStepZero = false;
          this.currentStep = this.currentStep + 1;
          this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
          if(this.GlobalConstants.client === 'smeoffers') {
            this.getUserCard();
          }
          this.submittedForm1 = false;
          this.countDown(180, () => {
            this.timer = 'complete';
          });
  
          setTimeout(() => {    //<<<---    using ()=> syntax
            document.getElementById("otp-field")?.focus();
          }, 1000);
          this.userId = response.id;
          this.userStatus = "activation";
        } else {
          this.invalidUser = true;
          this.submittedForm1 = false;
        }
      }, error => {
        this.isload1 = false;
        if (error.error) {
          this.errorRequestingOtpMsg = error.error.errors.join(", ");
        } else {
          this.errorRequestingOtpMsg = "Please check your eligibility.";
        }
  
        this.errorRequestingOtp = true;
        this.submittedForm1 = false;
  
      })

    }
  }
  validateUserOtp() {
    if (this.otpInp && this.otpInp.length == 6) {
      this.otpVerifying = true;
        this._auth.validateUserOtp(this.userId, this.otpInp, this.userStatus, this.mobNum).subscribe((response) => {
          if (response && response.token) {
            if(this.GlobalConstants.data.personalized_config.has_card){
              this.getUserCard();
            }
            else{
              this.showIfNotAuthenticated = false;
              this.stepToShow = null;
              localStorage.setItem('card_verified', "true");
            }
          } else {
            // if(response && response.wrong_attempts_left && response.wrong_attempts_left == 0){
            //   this.errorRequestingOtpMsg = "Maximum invalid OTP attempts reached";
            // }
            this.invalidOtp = true;
            this.validOtp = false;
            this.otpVerifying = false;
          }
        }, (err) => {
          console.log(err)
          this.otpVerifying = false;
          this.errorRequestingOtp = true;
          this.errorRequestingOtpMsg = "Please check the entered OTP";
        })
    }
  }

  getUserCard() {
    this.fetchingCard = true;
    const api = this.GlobalConstants.client === 'smeoffers' ? this._apiService.getCardsbyProject() : this._apiService.getCards();
    api.subscribe((response) => {
      this.fetchingCard = false;
      if (response && response.data && (response.data.length > 0 || response.data.attributes)) {
          // let thebin = localStorage.getItem('thebin');
          var currentCard
          if (response.data.attributes) {
            currentCard[0] = response.data;
          }
          else {
            currentCard = response.data.filter((x) => { return x.attributes.bin == this.thebin });
          }
          var card;
          console.log(currentCard)
          if (currentCard.length > 0) {
            console.log('yes2')
            card = JSON.stringify(currentCard[0]);
            const cardObj = JSON.stringify({
               id: currentCard[0].id, 
               attributes: {
                 display_name: currentCard[0].attributes.display_name
                }
              })
            localStorage.setItem('uC', cardObj);
            this.subscriptions.push(this.dataTransferService.userCard$.subscribe(res => {
              if(res && res.id == currentCard[0].id){
                return
              } else {
                this.dataTransferService.nextUserCard(currentCard[0]);
              }
            }))
            const userCards = response.data.map((res) => {
              const cardIdObj = {id: res.id};
              return cardIdObj
            })
            localStorage.setItem("uCs", JSON.stringify(userCards));
            
            this.dataTransferService.nextUserCards(response.data);
            // if(this.GlobalConstants.client !== 'smeoffers') {
              this.checkIfBinValid(currentCard[0].attributes.bin, currentCard[0].attributes.bin_type);
            // }
          }
          else {
            this.addCard(this.GlobalConstants.data.card_num_type,true, true);
          }
      } else {
          this.addCard(this.GlobalConstants.data.card_num_type,false, true);
      }
    });
  }

  addCard(bin_type, reload = false, binCheck = false) {
    // let thebin = localStorage.getItem('thebin');
    this._apiService.addCard(this.thebin, bin_type, this.iFrameData).subscribe((response) => {
        if (response && response.data && response.data.attributes) {
          const cardObj = JSON.stringify({
            id: response.data.id, 
            attributes: {
              display_name: response.data.attributes.display_name
            }
          })
        localStorage.setItem('uC', cardObj);
        this.subscriptions.push(this.dataTransferService.userCard$.subscribe(res => {
          if(res && res.id == response.data.id){
            return
          } else {
            this.dataTransferService.nextUserCard(response.data);
          }
        }))
        localStorage.setItem('card_verified', "true");
        localStorage.removeItem('uCs');
        this.showIfNotAuthenticated = false;
        this.stepToShow = null;
        this.validOtp = true;

        if (binCheck) {
          this.checkIfBinValid(this.thebin, this.GlobalConstants.data.card_num_type);
        }
        else if (reload) {
          // this.reloadInit();
          location.reload();
        }
      } 
    }, (err) => {
      if (err?.status === 422) {
        // this.errorRequestingOtp = true;
        // this.errorRequestingOtpMsg = $localize``
      }
    });
  }
  checkIfBinValid(bin, bin_type) {
    this._apiService.validateCard(bin, bin_type).subscribe(res => {
      this.isload2 = false;
      if (res && res.data && res.data.attributes.bin == bin && res.data.attributes.status == 'bin_verified') {
        let current_user = JSON.parse(localStorage.getItem("currentUser"));
        current_user = current_user ? current_user : {};
        current_user.token = res.data.attributes.session_token;
        localStorage.setItem('currentUser', JSON.stringify(current_user));
        if (this.locale === 'ja' || this.selectedCountry?.iso2_code === 'JP') {
          localStorage.setItem('isJaToken', 'true');
        }
        this._auth.updateCurrentUser(current_user);
        this.cardVerified = true;
        localStorage.setItem('card_verified', "true");
        const cardObj = JSON.stringify({
          id: res.data.id, 
          attributes: {
            display_name: res.data.attributes.display_name
          }
        })
      localStorage.setItem('uC', cardObj);
      this.subscriptions.push(this.dataTransferService.userCard$.subscribe(response => {
        if(response && response.id == res.data.id){
          return
        } else {
          this.dataTransferService.nextUserCard(res.data);
        }
      }))
        let usercurrentcard = JSON.stringify(res);
        // localStorage.setItem('uC', usercurrentcard);

        this.showIfNotAuthenticated = false;
        this.binError = false;
        this.binInvalid = false;
        this.otpVerifying = false;
        this.validOtp = true;
        // this.reloadInit();
        const redirectData = JSON.parse(localStorage.getItem("redirectData"))
        this.toastr.success($localize`Logged In Successfully`,'', {
          timeOut: 6000,
        });
        this.addLocation();
        if(redirectData){
          localStorage.removeItem('redirectData')
          if(redirectData.redirectLink){
            this.router.navigate([redirectData.subProjectCode,'offers',redirectData.redirectLink])
          }
          else{
            this.router.navigate([redirectData.subProjectCode,'offers'])
          }
          // window.location.href = redirectData.subProjectCode+'/offers';
        }
        else{
          this.dataTransferService.nextReloadEvent(true)
          // location.reload();
        }
        localStorage.removeItem('headerLogin')

      }
      else {
        this.binError = true;
        this.otpVerifying = false;
        this.toastr.error($localize`Something went wrong. Please try again!`);
        localStorage.setItem('card_verified', "false");
      }
    })
  }

  addLocation(){
    let userLocation = JSON.parse(localStorage.getItem("userLocation"));
    if(userLocation && userLocation.country && userLocation.country.id){
      let params = {
        country_id: userLocation.country.id,
        // locality_id:
      }
      if(userLocation.state && userLocation.state.id){
        params['city_id'] = userLocation.state.id;
      }
      this._apiService.addLocation(params).subscribe(res => {});
    }
  }
  addCardFormSubmit() {
    if (this.binError) {
      this._auth.logout();
      window.location.href = "/";
    }
    this.isload2 = true;
    let bin = this.addCardForm.value.binFirst4.toString() + this.addCardForm.value.binLast4.toString();
    bin += this.GlobalConstants.data.card_num_type == 'first9' ? this.addCardForm.value.binLast1.toString() : '';
    // localStorage.setItem('thebin', bin);
    this.thebin  = bin;
    this.cardValidation(bin);
  }


  getAllCountries(countryCode?) {
    if(!countryCode){
      var countryCode;
    }
    let allCountries = JSON.parse(localStorage.getItem("allCountries"));
    if(!allCountries || allCountries.length == 0){
      this._apiService.getAllCountries().subscribe(
        (res: any) => {
          this.processCountries(res.data, countryCode)
          localStorage.setItem('allCountries', JSON.stringify(this.allCountries))
        }
      )
    }
    else{
      this.processCountries(allCountries, countryCode)
    }
  }
  processCountries(allCountries, countryCode?){
    this.popularCountries = [];
    this.otherCountries = [];
    this.allCountries = [];
    allCountries.sort(function (a, b) {
      var textA = a.attributes.name.toUpperCase();
      var textB = b.attributes.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    if (allCountries && allCountries.length > 0) {
      this.allCountries = allCountries.map(obj => {
        let mobile_length = obj.attributes.mobile_length.split('...');
        obj.attributes.min_mobile_digit = parseInt(mobile_length[0]);
        obj.attributes.max_mobile_digit = parseInt(mobile_length[1]) - 1;
        if (this.featuredCountryCodes.includes(obj.attributes.iso_code)) {
          this.popularCountries.push(obj);
        } else {
          this.otherCountries.push(obj);
        }
        return obj;
      })
      var country;
      if(countryCode){
        country = this.allCountries.filter((x) => { return x.attributes.code == countryCode })
      }
      else{
        country = this.allCountries.filter((x) => { return x.attributes.name == "India" })
      }
      if (country.length > 0) {
        if (!localStorage.getItem("userCountry")) {
          this.selectedCountry = country[0].attributes;
          localStorage.setItem("userCountry", JSON.stringify(country[0]));
        } else {
          const userCountry = JSON.parse(localStorage.getItem("userCountry"));
          if (!userCountry?.attributes?.min_mobile_digit || !userCountry?.attributes?.max_mobile_digit) {
            this.selectedCountry = country[0].attributes;
            localStorage.setItem("userCountry", JSON.stringify(country[0]));
          } else {
            this.selectedCountry = userCountry?.attributes;
          }
        }
        // this.getIFrameToken();
      }
      else {
        this.selectedCountry = null;
      }

      // sort popular countries array w.r.t featured array
      this.popularCountries.sort( (a, b) => {
        return this.featuredCountryCodes.indexOf(a.attributes.iso_code) - this.featuredCountryCodes.indexOf(b.attributes.iso_code);
      });

      // alphabetically sort other countries
      this.otherCountries.sort(function (a, b) {
        var textA = a.attributes.name.toUpperCase();
        var textB = b.attributes.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
      this.allCountries = this.popularCountries.concat(this.otherCountries);
      this.filteredCountries = this.allCountries;
    }
    else {
      this.selectedCountry = null;
    }

  }
  filteredCountries = [];
  filterItem(searchTerm){
   if(searchTerm && searchTerm.length > 0){
      this.filteredCountries = Object.assign([], this.allCountries).filter(
        item => item.attributes.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
     )
   }
  }
  setCountry(country) {

    this.selectedCountry = country.attributes;
    localStorage.setItem("userCountry", JSON.stringify(country));
  }
  onKeyph(e) {
    this.binError = false;
    this.binInvalid = false;
    this.userCardsText = "";
    e.target.value = e.target.value.replace(/[^\d]/g, '').trim();
  }
  keytab(event, el) {
    this.binError = false;
    this.binInvalid = false;
    this.isload2 = false;
    this.userCardsText = "";
    if (event.currentTarget.value.length == 4) {
      // document.getElementById('last_four_card_digits').focus();
      el.focus();
    }
  }
  btnActive: boolean = false;

  resetLoginAgain() {
    this.clearAll();
    this.submittedForm1 = false;
    this.fetchingCard = false;
    this.searchLoader = false;
    this.isload1 = false;
    this.isload2 = false;
    this.stepToShow = this.GlobalConstants.data.login_steps[0];
    this.currentStep = 0;
    this.mobNum = undefined;
    this.mobileInputBtnActive = false;
    this.errorRequestingOtp = false;
    this.errorRequestingOtpMsg = "";

    if (this.createWithUserForm.controls) {
      if (this.createWithUserForm.controls['mobile']) {
        this.createWithUserForm.controls['mobile'].setValue("");
      }
      if (this.createWithUserForm.controls['otp']) {
        this.createWithUserForm.controls['otp'].setValue("");
      }
    }
    this.otpInp = '';
    this.showIfNotAuthenticated = true;
    this.userSearching = false;
    this.validOtp = false;
    (clearInterval(this.int), function () { });
  }
  cardValidation(bin) {
    this._apiService.cardValidation(bin).subscribe(res => {
      this.isload2 = false;
      if (res && res.success) {
        this.userCardJson = res.detail;

        // let userCards = this.userCardJson.map((x) => {return `${x.issuer} ${x.card_group.name} ${x.card_type} card`.toLowerCase()})
        this.userCardsText = `${this.userCardJson.issuer || ""} ${this.userCardJson.name || ""} ${this.userCardJson.card_type || ""} Card`;
        this.cardVerified = true;
        if(this.allCountries){
          this.processCountries(this.allCountries, res.detail.country_code)
        }
        else{
          this.getAllCountries(res.detail.country_code);
        }
        localStorage.setItem('card_verified', "true");
        localStorage.setItem('cb', btoa(bin));
        this.currentStep = this.currentStep + 1;
        if (this.GlobalConstants.data.login_steps[this.currentStep]) {
          this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
        }
        else {
          this.stepToShow = null;
        }
        this.binError = false;
        this.binInvalid = false;
        if (!this.stepToShow) {
          this.showIfNotAuthenticated = false;
          this.toastr.success($localize`Logged In Successfully`,'', {
            timeOut: 6000,
          });
          // this.addLocation();
          this.dataTransferService.nextReloadEvent(true)
          localStorage.removeItem('headerLogin')
        }
      } else {
        this.binError = true;
        if(res && res.detail && res.detail.name){
          this.notApplicableCard = true;
        }
        else{
          this.notApplicableCard = true;
        }
        localStorage.setItem('card_verified', "false");
      }
    })
  }
  checkbtn() {
    let bin = this.addCardForm.value.binFirst4.length + this.addCardForm.value.binLast4.length;
    bin += this.GlobalConstants.data.card_num_type == 'first9' ? this.addCardForm.value.binLast1.length : 0;
    if ((this.GlobalConstants.data.card_num_type == 'first6' && bin == 6)
        || (this.GlobalConstants.data.card_num_type == 'first8' && bin == 8)
           ||  (this.GlobalConstants.data.card_num_type == 'first9' && bin == 9)) {
      this.btnActive = true;
    }
    else {
      this.btnActive = false;
    }
  }

  backkeytab(event, firstFocusable) {
    this.binError = false;
    this.binInvalid = false;
    this.isload2 = false;

    if (event.currentTarget.value.length == 0 && event.key == 'Backspace') {
      let elem = document.getElementById('first_four_card_digits')
      // elem.value = elem.value.slice(0, 3);
      firstFocusable ? firstFocusable.focus() : elem.focus();
    }

  }

  int: any;
  countDown(i, callback) {

    callback = callback || function () { };
    this.int = setInterval(() => {
      this.timer = 'started';
      this.viewTimer = i;
      const minutes: number = Math.floor(i / 60);
      this.timerToShow = minutes + ':' + (i - minutes * 60);

      i-- || (clearInterval(this.int), callback());
    }, 1000);
  }

  resetCountDown(i, callback) {

    callback = callback || function () { };
    var int = setInterval(() => {
      this.timer = 'started';
      this.viewTimer = i;
      const minutes: number = Math.floor(i / 60);
      this.timerToShow = minutes + ':' + (i - minutes * 60);

      i-- || (clearInterval(int), callback());
    }, 1000);
  }

  restartLogin() {
    this.clearAll();
    if (!this.allCountries || this.allCountries.length == 0) {
      this.getAllCountries();
    }
    this.currentStep = 0;
    this.stepToShow = this.GlobalConstants.data.login_steps[0];
    this.showIfNotAuthenticated = true;

    this.userSearching = false;
    this.errorRequestingOtp = false;
    this.validOtp = false;
    this.createWithUserForm.patchValue({ mobile: '' });
    this.createWithUserForm.patchValue({ email: '' });
    this.mobNum = undefined;
    this.otpInp = undefined;
    this.errorRequestingOtpMsg = '';
    this.addCardForm.patchValue({ binFirst4: '' });
    this.addCardForm.patchValue({ binLast4: '' });
    this.addCardForm.patchValue({ binLast1: '' });
    this.getIFrameToken();
  }

  clearOtp() {
    document.getElementById("otp-field")?.focus();
    this.otpInp = '';
  }
  clearCardInput(){
    this.addCardForm.patchValue({ binFirst4: '' });
    this.addCardForm.patchValue({ binLast4: '' });
    this.addCardForm.patchValue({ binLast1: '' });
  }

  theme2loginSetings = {
    showCardInput: false,
    showOtp: false
  }
  mobileLengthCheck(lengthToCheck) {
    this.theme2loginSetings.showCardInput = this.mobNum.length == lengthToCheck ? true : false;
  }


  getUserDetails(){
    this._apiService.getUserDetails().subscribe((res: any) => {
      this.userEmail = res.email;
      if(!res.email_verified || res.email_verified == 'false'){
        // if(this.isMobile){
          // this.showEmailConfirm();
        // }
      }
      else{
        localStorage.setItem('ev','true');
      }
    });
  }

  showEmailConfirm(){

    const initialState = {
      existingEmail: this.userEmail ? this.userEmail : null
    }
    var config = {
      backdrop: true,
      ignoreBackdropClick: false
    };
    this.modalRef = this._modalService.show(ConfirmEmaiModalComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.hideEvent.subscribe(res => {
      if (res) { this.modalRef.hide(); }
    })
  // }
  // else{
  //   this.showMobEmailBtn = true;
  // }

  }

  ngOnDestroy(): void {
      localStorage.removeItem('thebin');
      this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  private getIFrameToken() {
    if (this.showIfNotAuthenticated && this.GlobalConstants.client === 'smeoffers' && (this.locale === 'ja' || this.selectedCountry?.iso2_code === 'JP')) {
      this.iFrameLoaded = false;
      this._apiService.getIFrameToken().subscribe((res: any) => {
        localStorage.setItem('iFrameData', JSON.stringify(res));
        this.iFrameData = res;
      })
    }
  }

  public validateToken() {
    if (this.iFrameData) {
      this._apiService.getVisaTokenStatus(this.iFrameData?.txn_id).subscribe((res: any) => {
        if (res && res.success) {
          this.userCardJson = res.detail;
          this.userCardsText = `${this.userCardJson.issuer || ""} ${this.userCardJson.name || ""} ${this.userCardJson.card_type || ""} Card`;
          this.thebin = this.userCardJson?.bin;
          localStorage?.setItem('thebin', this.userCardJson?.bin)
          this.cardVerified = true;
          if(this.allCountries?.length){
            this.processCountries(this.allCountries, res.detail.country_code)
          }
          else{
            this.getAllCountries(res.detail.country_code);
          }
          localStorage.setItem('card_verified', "true");
          this.currentStep = this.currentStep + 1;
          this.showIfNotAuthenticated = true;
          this.stepToShow = 'mobile';
          this.binError = false;
          this.binInvalid = false;
        } else {
          this.getIFrameToken();
          this.binError = true;
          if(res && res.detail && res.detail.name){
            this.notApplicableCard = true;
          }
          else{
            this.notApplicableCard = true;
          }
          localStorage.setItem('card_verified', "false");
        }
      })
    }
  }
}
